// extracted by mini-css-extract-plugin
module.exports = {"i5qaoq3":"i5qaoq3"};